import { useEffect, useState } from 'react';
import useVideoContext from '../useVideoContext/useVideoContext';

type RoomStateType = 'disconnected' | 'connected' | 'reconnecting';

export default function useRoomState() {
  const { room } = useVideoContext();
  const [state, setState] = useState<RoomStateType>('disconnected');

  useEffect(() => {
    if (room) {
      // When the room disconnects, App switches back to the pre-join screens and unmounts components that use this
      // hook while the 'disconnected' event is still being delivered. EventEmitter calls every listener that was
      // registered when the event was emitted, so ignore calls that arrive after this effect was cleaned up.
      let isSubscribed = true;
      const setRoomState = () => {
        if (isSubscribed) setState(room.state as RoomStateType);
      };
      setRoomState();
      room
        .on('disconnected', setRoomState)
        .on('reconnected', setRoomState)
        .on('reconnecting', setRoomState);
      return () => {
        isSubscribed = false;
        room
          .off('disconnected', setRoomState)
          .off('reconnected', setRoomState)
          .off('reconnecting', setRoomState);
      };
    }
  }, [room]);

  return state;
}
